import React from 'react';
import { cn } from '@/lib/utils';

interface WatermarkedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    watermark?: boolean;
    containerClassName?: string;
    variant?: 'thumbnail' | 'full';
}

export const WatermarkedImage: React.FC<WatermarkedImageProps> = ({
    watermark = true,
    className,
    containerClassName,
    alt,
    variant = 'thumbnail',
    ...props
}) => {
    if (!watermark) {
        return (
            <img
                className={cn("block", className)}
                alt={alt}
                {...props}
            />
        );
    }

    const renderWatermark = () => {
        const watermarkContent = (
            <div className="transform -rotate-12 opacity-40 select-none pointer-events-none">
                <span className="text-white text-4xl font-bold tracking-widest drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)] border-4 border-white/50 px-4 py-2 rounded-lg">
                    FOTUP
                </span>
            </div>
        );

        if (variant === 'full') {
            return (
                <div className="absolute inset-0 pointer-events-none flex flex-col items-center justify-between py-12 z-10">
                    {/* Top Watermark */}
                    <div className="transform translate-y-4">
                        {watermarkContent}
                    </div>
                    
                    {/* Center Watermark */}
                    <div>
                        {watermarkContent}
                    </div>

                    {/* Bottom Watermark */}
                    <div className="transform -translate-y-4">
                        {watermarkContent}
                    </div>
                </div>
            );
        }

        // Default thumbnail variant (single center watermark)
        return (
            <div className="absolute inset-0 pointer-events-none flex flex-col items-center justify-center z-10">
                {watermarkContent}
            </div>
        );
    };

    return (
        <div 
            className={cn("relative overflow-hidden select-none", containerClassName)}
            onContextMenu={(e) => e.preventDefault()}
        >
            <img
                alt={alt}
                {...props}
                className={cn("block w-full h-full object-cover pointer-events-none", className)}
            />
            
            {/* Watermark Overlay */}
            {renderWatermark()}
            
            {/* Repeating background pattern */}
            <div className="absolute inset-0 opacity-[0.03] bg-[url('/watermark-pattern.png')] bg-repeat pointer-events-none" />

            {/* Bottom Rights Reserved */}
            <div className="absolute bottom-2 w-full text-center z-10 pointer-events-none">
                <span className="text-white/60 text-[10px] uppercase tracking-wider drop-shadow-md font-medium bg-black/20 px-2 py-1 rounded">
                    © Fotup - Direitos Reservados
                </span>
            </div>
        </div>
    );
};
